import React from "react";
import { components } from "react-select";
import AsyncSelect from "react-select/async";

import Avatar from "../../../Components/Avatar";
import { getPerformYardEmployees } from "../../../Api/services/employees";

export const EmployeeSelector = (props) => {
	const loadOptions = (inputValue) => {
		return getPerformYardEmployees(props.environment, { email: inputValue });
	};

	const Option = (props) => {
		return (
			<components.Option {...props}>
				<div style={{ display: "flex", alignItems: "center" }}>
					<div style={{ marginRight: "12px" }}>
						<Avatar userID={props.data._id} size={24} />
					</div>
					<div>
						<div>{props.data.name}</div>
						<div style={{ fontSize: "0.8em", color: "#666" }}>
							{props.data.email} {props.data.company && `- ${props.data.company}`}
						</div>
					</div>
				</div>
			</components.Option>
		);
	};

	return (
		<AsyncSelect
			components={{ Option }}
			loadOptions={loadOptions}
			cacheOptions
			defaultOptions
			onChange={props.onChange}
		/>
	);
};
